// import moment from 'moment';
import * as actionTypes from "../action-types";
import * as api from "../../api";
// import { v4 as uuidv4 } from "uuid";
// import { chain, filter, has, isEmpty, forEach, includes } from 'lodash'
// import { toBoolean } from '../StoreHelpers';

export const portalFlow =
    ({ dispatch, getState }) =>
    (next) =>
    (action) => {
        next(action);
        switch (action.type) {
            
            case actionTypes.SET_STATE:
                
                dispatch({ type: actionTypes.API_GET_TNC_START });

                api.get(`/web-convincely/v1.0/api/tnc`, {
                    params: { 
                        state: action.payload
                    }
                })
                .then((response) => {
                    dispatch({ type: actionTypes.API_GET_TNC_SUCCESS, payload: response.data });
                })
                .catch((error) => {
                    dispatch({ type: actionTypes.API_GET_TNC_FAIL });
                });
                break;

            default:
                break;
        }
    };

export const loyaltyMDL = [portalFlow];
